import { loadScript } from './loadScript';

export function usercentricsEnabled() {
  return window?.__MOVINGIMAGE_CT_USERCENTRICS_CONFIG?.enabled ? window.__MOVINGIMAGE_CT_USERCENTRICS_CONFIG.enabled : false;
}

export async function initUsercentrics(config) {
  addDomains();

  return loadScript({
    id: 'usercentrics-cmp',
    src: 'https://usercentrics.movingimage.com/app/browser-ui/latest/bundle.js',
    type: 'text/javascript',
    dataset: { settingsId: config.settingsId, tcfEnabled: true, language: getBrowserLanguage() },
  });
}

function addDomains() {
  window.UC_UI_DOMAINS = {
    aggregator: 'https://usercentrics.movingimage.com/aggregator',
    app: 'https://usercentrics.movingimage.com/app',
    cdn: 'https://usercentrics.movingimage.com/cdn',
    consents: 'https://usercentrics.movingimage.com/consents',
    consentsV2: 'https://usercentrics.movingimage.com/consentsv2',
    graphql: 'https://usercentrics.movingimage.com/graphql',
    trackingEvent: 'https://usercentrics.movingimage.com/tracking',
  };
}

function getBrowserLanguage() {
  const locale = window.navigator.language;
  const language = locale.split('-')[0];
  return language;
}
